import { AccountService, NotificationService } from "@3gaam/api/services";
import { store } from "@3gaam/app/src/store";
import {
  changeLoginStateAction,
  logoutAction,
} from "@3gaam/app/src/store/auth";
import { isInitialized, unsubscribe } from "@3gaam/shared/utils/firebase";

export type Options = {
  clearCookie: boolean;
};

export const logoutHandler = (options: Options) => {
  return new Promise((resolve) => {
    const clearCookie = options.clearCookie ?? true;

    const clientId =
      store.getState().message.notification.registerInfo?.ClientId;

    if (isInitialized() && clientId) {
      unsubscribe()
        .then(() => {
          NotificationService.unRegister({
            CurrentClientId: clientId,
          }).catch(() => {});
        })
        .finally(() => {
          if (clearCookie) {
            store.dispatch(logoutAction(true));
            AccountService.logout({}).finally(() => {
              store.dispatch(changeLoginStateAction(false));
              localStorage.clear();
              resolve(undefined);
            });
          } else {
            localStorage.clear();
            store.dispatch(changeLoginStateAction(false));
            resolve(undefined);
          }
        });
    } else {
      AccountService.logout({}).finally(() => {
        if (clearCookie) {
          store.dispatch(logoutAction(true));
        }
        localStorage.clear();
        store.dispatch(changeLoginStateAction(false));
        resolve(undefined);
      });
    }
  });
};
